var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Nome UC",
                  content:
                    _vm.dadosJson.informacoesAdministrativasUc.nomeUc || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Esfera Administrativa:",
                  content:
                    _vm.dadosJson.informacoesAdministrativasUc
                      .esferaAdministrativa || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Objetivo Criação UC:",
                  content:
                    _vm.dadosJson.informacoesAdministrativasUc
                      .objetivoCriacaoUc || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Órgão Gestor:",
                  content:
                    _vm.dadosJson.informacoesAdministrativasUc.orgaoGestor ||
                    "-"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Tipo UC:",
                  content:
                    _vm.dadosJson.informacoesAdministrativasUc.tipoUc || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Tipo UC Proteção Integral:",
                  content:
                    _vm.dadosJson.informacoesAdministrativasUc
                      .tipoUcProtecaoIntegral || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Tipo UC Uso Sustentável:",
                  content:
                    _vm.dadosJson.informacoesAdministrativasUc
                      .tipoUcUsoSustentavel || "-"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e13c68ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e13c68ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesAdministrativasUc.vue
// module id = null
// module chunks = 